import { createActions, createState, createReducer } from 'reduxsauce-crud'
const d = { deep: true }

export const UsersRedux = createActions({
    postUserPicutreRequest: ['id', 'data'],
    postUserPicutreSuccess: [''],
    postUserPicutreError: ['error'],
    postUserTokenFCMRequest: ['id', 'data'],
    postUserTokenFCMSuccess: [''],
    postUserTokenFCMError: ['error'],
}, {
    prefix: 'USERS_',
    defaultActions: {
        get: true,
    },
})

const { Types, Creators } = UsersRedux
export const UsersTypes = Types
export default Creators

export const INITIAL_STATE = createState({
    picture: {
        fetching: false,
        error: null
    },
    fcm: {
        fetching: false,
        error: null
    }
}, {
    get: true,
})


const postUserPicutreRequest = state => state.merge({ picture: { fetching: true } }, d)
const postUserPicutreSuccess = (state) => (
    state.merge({ picture: { fetching: false } }, d)
)
const postUserPicutreError = (state, { error }) => (
    state.merge({ picture: { fetching: false, error } }, d)
)
const postUserTokenFCMRequest = state => state.merge({ fcm: { fetching: true } }, d)
const postUserTokenFCMSuccess = (state) => (
    state.merge({ fcm: { fetching: false } }, d)
)
const postUserTokenFCMError = (state, { error }) => (
    state.merge({ fcm: { fetching: false, error } }, d)
)

export const reducer = createReducer(INITIAL_STATE, {
    [Types.postUserPicutreRequest]: postUserPicutreRequest,
    [Types.postUserPicutreSuccess]: postUserPicutreSuccess,
    [Types.postUserPicutreError]: postUserPicutreError,
    [Types.postUserTokenFCMRequest]: postUserTokenFCMRequest,
    [Types.postUserTokenFCMSuccess]: postUserTokenFCMSuccess,
    [Types.postUserTokenFCMError]: postUserTokenFCMError,
}, {
    defaultActions: {
        get: true,
    },
    Types,
})



// WEBPACK FOOTER //
// ./src/Data/Redux/UsersRedux.js